/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RemoteCommandInput = {
    command: RemoteCommandInput.command;
};
export namespace RemoteCommandInput {
    export enum command {
        NEXT = 'next',
        PREV = 'prev',
        BLACK = 'black',
        WHITE = 'white',
        RESUME = 'resume',
        FIRST = 'first',
        LAST = 'last',
        SCROLLUP = 'scrollup',
        SCROLLDOWN = 'scrolldown',
    }
}

